import { j as e } from "./jsx-runtime-DmTjM30f.mjs";
import { c as n } from "./tw-cn-mXgPecoF.mjs";
import { R as x } from "./rectangle-button-Oc2I1olX.mjs";
const p = ({ icon: c, title: i, description: l, buttons: a, pcType: m = "pcSize" }) => {
  const r = m === "pcLegacySize";
  return /* @__PURE__ */ e.jsxs("div", { className: "flex max-w-[360px] flex-col items-center p-32", children: [
    !!c && /* @__PURE__ */ e.jsx("div", { className: "mb-12", children: /* @__PURE__ */ e.jsx(c, { className: "text-fill-neutral-weak4" }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center", children: [
      /* @__PURE__ */ e.jsx("div", { className: "line-clamp-2 text-center text-text-neutral-main typography-subtitle-16-regular", children: i }),
      !!l && (typeof l == "string" ? /* @__PURE__ */ e.jsx("div", { className: "mt-4 line-clamp-2 text-center text-text-neutral-sub typography-body-14-regular", children: l }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: l }))
    ] }),
    !!(a != null && a.length) && /* @__PURE__ */ e.jsx("div", { className: "mt-16 flex flex-col", children: a.map((s, t) => /* @__PURE__ */ e.jsx(
      x,
      {
        className: n("min-w-180", {
          "last:mt-8": t !== 0
        }),
        onClick: s.onClick,
        size: {
          pc: r ? "medium" : "large"
        },
        theme: t === 0 ? "outlined_secondary" : "outlined_basic",
        weight: "bold",
        children: /* @__PURE__ */ e.jsx("div", { className: "line-clamp-1", children: s.content })
      },
      t
    )) })
  ] });
};
p.displayName = "NDS.EmptyState";
export {
  p as E
};
